var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('div',{staticClass:"my-3"},[_c('div',{class:['text-body-2 ', _vm.error ? 'error--text' : 'text--secondary']},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{class:['text-body-1', _vm.error ? 'error--text' : 'text--primary']},[_vm._v(" "+_vm._s(_vm.text)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }